import { ACL_TYPE } from '@openx/types/aclType.ts';
import { usePermissionContext } from '@openx/utils/permission/context/PermissionContext.tsx';
import { isAllowedByCompiledAcl } from '@openx/utils/permission/validators.ts';
import { CuratedDealFeesFormSectionInteractive } from './CuratedDealFeesFormSectionInteractive.tsx';
import { CuratedDealFeesFormSectionReadOnly } from './CuratedDealFeesFormSectionReadOnly.tsx';

type CuratedDealFeesFormSectionProps = {
  isEdit: boolean;
};

export const CuratedDealFeesFormSection = ({ isEdit }: CuratedDealFeesFormSectionProps) => {
  const { useIsAllowed } = usePermissionContext();
  const { isAllowed } = useIsAllowed();

  if (isAllowed(isAllowedByCompiledAcl(ACL_TYPE.THIRD_PARTY_FEES_WRITE))) {
    return <CuratedDealFeesFormSectionInteractive isEdit={isEdit} />;
  }

  if (isAllowed(isAllowedByCompiledAcl(ACL_TYPE.THIRD_PARTY_FEES_READ))) {
    return <CuratedDealFeesFormSectionReadOnly />;
  }

  return null;
};
